import { createPersistedStore } from './store-creators';

type BetaSeenState = {
  seenFeatures: Record<string, boolean>;
  markSeen: (key: string) => void;
};

export const useBetaSeenStore = createPersistedStore<BetaSeenState>(
  (set) => ({
    seenFeatures: {},
    markSeen: (key: string) =>
      set((state) => ({
        seenFeatures: { ...state.seenFeatures, [key]: true }
      }))
  }),
  {
    name: 'beta-seen',
    partialize: (state) =>
      ({ seenFeatures: state.seenFeatures }) as typeof state
  }
);
